// Punto de arranque. Monta el orquestador y prepara el modo sin internet.
//
// El trabajador de internet (service worker) SOLO se registra en la versión
// publicada. En desarrollo no: ahí Vite ya recarga la página por su cuenta
// cada vez que cambia un archivo, y los dos juntos dejaban la pantalla
// recargándose a media captura. Ver actualizacion.jsx y vite.config.js.
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { prepararActualizaciones } from "./actualizacion.jsx";

createRoot(document.getElementById("raiz")).render(<App />);

if (import.meta.env.PROD) window.addEventListener("load", prepararActualizaciones);
